import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { IconEdit } from "../../icons/IconEdit";
import { IconTrash } from "../../icons/IconTrash";
import { IconBell } from "../../icons/IconBell";
import "./CardActionMenu.css";

export type MenuPosition = {
  top: number;
  left: number;
};

type CardActionMenuProps = {
  canEdit: boolean;
  canDelete: boolean;
  position: MenuPosition;
  onClose: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onReport?: () => void;
};

export const CardActionMenu: React.FC<CardActionMenuProps> = ({
  canEdit,
  canDelete,
  position,
  onClose,
  onEdit,
  onDelete,
  onReport,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const menuContent = (
    <div
      className="card-action-menu"
      ref={menuRef}
      style={{
        top: position.top,
        left: position.left,
      }}
    >
      <ul className="card-action-menu__list">
        {canEdit && (
          <li>
            <button className="card-action-menu__option" onClick={(e) => { e.stopPropagation(); onEdit?.(); }}>
              <span className="card-action-menu__icon">
                <IconEdit size={16} />
              </span>
              <span className="card-action-menu__label">Edit</span>
            </button>
          </li>
        )}
        {canDelete && (
          <li>
            <button
              className="card-action-menu__option card-action-menu__option--danger"
              onClick={(e) => { e.stopPropagation(); onDelete?.(); }}
            >
              <span className="card-action-menu__icon">
                <IconTrash size={16} />
              </span>
              <span className="card-action-menu__label">Delete</span>
            </button>
          </li>
        )}
        {!canEdit && (
          <li>
            <button className="card-action-menu__option" onClick={(e) => { e.stopPropagation(); onReport?.(); }}>
              <span className="card-action-menu__icon">
                <IconBell />
              </span>
              <span className="card-action-menu__label">Report</span>
            </button>
          </li>
        )}
      </ul>
    </div>
  );

  return createPortal(menuContent, document.body);
};
